import hrms13xLabels from 'assets/labels/hrms13x'
import faker from 'faker'
import moment from 'moment'

export const mocker = {
  labels () {
    return {
      labels: hrms13xLabels
    }
  },
  index () {
    let mockRows = []
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        id: i,
        codempid: faker.lorem.word(),
        desc_codempid: faker.name.findName(),
        desc_codcomp: faker.name.jobType(),
        desc_codpos: faker.name.title(),
        numlvl: faker.random.number().toString().substr(0, 2),
        dteempmt: moment(faker.date.past()).format('DD/MM/YYYY')
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detail () {
    let mockTab1 = {
      empimg: '',
      codcomp_desc: faker.name.jobType(),
      codpos_desc: faker.name.title(),
      codjob_desc: faker.name.jobDescriptor(),
      codempmt_desc: 'Monthly',
      numlvl: faker.random.number().toString().substr(0, 2),
      typemp_desc: 'Contract staff',
      typpayroll_desc: 'Monthly',
      salary: faker.commerce.price(),
      dteempmt: moment(faker.date.past()).format('DD/MM/YYYY'),
      dteempmt_yr: faker.random.number().toString().substr(0, 1),
      dteempmt_mt: faker.random.number().toString().substr(0, 1),
      dteempdb_yr: faker.random.number().toString().substr(0, 1),
      dteempdb_mt: faker.random.number().toString().substr(0, 1),
      dteeflvl_yr: faker.random.number().toString().substr(0, 1),
      dteeflvl_mt: faker.random.number().toString().substr(0, 1),
      dteefpos_yr: faker.random.number().toString().substr(0, 1),
      dteefpos_mt: faker.random.number().toString().substr(0, 1),
      codedlv_desc: 'Test Description',
      codinst_desc: 'Test Description',
      codmajsb_desc: 'Test Description',
      codminsb_desc: 'Test Description'
    }
    let mockTab2Rows = []
    const mockTab2Total = 1
    for (var i = 1; i <= mockTab2Total; i++) {
      mockTab2Rows.push({
        numseq: faker.random.number().toString().substr(0, 2),
        desnoffi: faker.commerce.productName(),
        deslstpos: faker.name.title(),
        dtestart: moment(faker.date.past()).format('DD/MM/YYYY'),
        dteend: moment(faker.date.past()).format('DD/MM/YYYY')
      })
    }
    let mockTab3Table1Rows = []
    const mockTab3Table1Total = 5
    for (var a = 1; a <= mockTab3Table1Total; a++) {
      mockTab3Table1Rows.push({
        dteeffec: moment(faker.date.past()).format('DD/MM/YYYY'),
        old_salary: faker.commerce.price(),
        amtincadj1_desc: faker.commerce.price()
      })
    }
    let mockTab3Table2Rows = []
    const mockTab3Table2Total = 5
    for (var b = 1; b <= mockTab3Table2Total; b++) {
      mockTab3Table2Rows.push({
        dteyreap: moment(faker.date.past()).format('YYYY'),
        grdap: faker.random.arrayElement().toString().toUpperCase()
      })
    }
    let mockTab4Rows = []
    const mockTab4Total = 5
    for (var c = 1; c <= mockTab4Total; c++) {
      mockTab4Rows.push({
        codpunsh_desc: 'ให้พักงานหักค่าจ้าง',
        punish_dte: moment(faker.date.past()).format('DD/MM/YYYY') + '-' + moment(faker.date.past()).format('DD/MM/YYYY'),
        desmist1: 'Test Description'
      })
    }
    let mockTab5Table1Rows = []
    const mockTab5Table1Total = 5
    for (var d = 1; d <= mockTab5Table1Total; d++) {
      mockTab5Table1Rows.push({
        detail: 'Name',
        codapp: 'hrms13x',
        typmenu: 'C'
      })
    }
    let mockTab5Table2Rows = []
    const mockTab5Table2Total = 5
    for (var e = 1; e <= mockTab5Table2Total; e++) {
      mockTab5Table2Rows.push({
        detail: 'Name',
        codapp: 'hrms13x',
        typmenu: 'C'
      })
    }
    let mockTab5Table3Rows = []
    const mockTab5Table3Total = 5
    for (var f = 1; f <= mockTab5Table3Total; f++) {
      mockTab5Table3Rows.push({
        detail: 'Name',
        codapp: 'hrms13x',
        typmenu: 'c'
      })
    }

    return {
      tab1: mockTab1,
      tab2: {
        total: mockTab2Total,
        rows: mockTab2Rows
      },
      tab3: {
        table1: {
          total: mockTab3Table1Total,
          rows: mockTab3Table1Rows
        },
        table2: {
          total: mockTab3Table2Total,
          rows: mockTab3Table2Rows
        }
      },
      tab4: {
        total: mockTab4Total,
        rows: mockTab4Rows
      },
      tab5: {
        table1: {
          total: mockTab5Table1Total,
          rows: mockTab5Table1Rows
        },
        table2: {
          total: mockTab5Table2Total,
          rows: mockTab5Table2Rows
        },
        table3: {
          total: mockTab5Table3Total,
          rows: mockTab5Table3Rows
        }
      }
    }
  },
  listFields () {
    let mockRowsEn = [
      { code: 'codempid', description: 'Employee Code', type: 'varchar2' },
      { code: 'numlvl', description: 'Number Level', type: 'number' },
      { code: 'codpos', description: 'Position Code', type: 'varchar2' },
      { code: 'dtestrt', description: 'Start Date', type: 'date' }
    ]

    let mockRowsTh = [
      { code: 'codempid', description: 'รหัสพนักงาน', type: 'varchar2' },
      { code: 'numlvl', description: 'ระดับ', type: 'number' },
      { code: 'codpos', description: 'รหัสตำแหน่ง', type: 'varchar2' },
      { code: 'dtestrt', description: 'วันที่เริ่มต้น', type: 'date' }
    ]

    return {
      en: mockRowsEn,
      th: mockRowsTh
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms13x/mocker.js